import { render, staticRenderFns } from "./UploadImage.vue?vue&type=template&id=678026ba&scoped=true&"
import script from "./UploadImage.vue?vue&type=script&lang=js&"
export * from "./UploadImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadImage.vue?vue&type=style&index=0&id=678026ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678026ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
